<template>
    <div>

        <ActionProviderMessageComplete
            v-if="action.isCompleted"
            :action="action"/>

        <v-treeview :items="test"
                    rounded
                    hoverable></v-treeview>

        <p class="text-right">
            <ActionProviderButtonComplete 
                    :action="action"
                    @completed="onCompleted"/>
        </p>

    </div>
</template>

<script>
import actionProvider from '@/mixins/actionProvider'

export default 
{
   name: 'ActionProviderTest',

   mixins: [ actionProvider ],

   components: 
   {

   },

   data: () => ({

   }),

   props: {
    test: {}
   },

   computed: {},

   methods:
   {

   },

   mounted()
   {

   }
}
</script>